// @ts-nocheck
import { supabase } from '@/lib/supabase';
import { invokeEdgeFunction } from "@/lib/invokeEdgeFunction";

/**
 * Send a recommendation notification email via Communication Hub
 * @param to Recipient email address
 * @param athleteName Name of the athlete
 * @param athleteId ID of the athlete
 */
export async function sendRecommendationEmail(to: string, athleteName: string, athleteId: string): Promise<any> {
  // Log values to confirm they are set correctly
  console.log("Sending email to:", to);
  console.log("Athlete name:", athleteName);
  
  try {
    // Queue email in Communication Hub via Edge Function
    const { error } = await invokeEdgeFunction('queue-communication', {
      body: {
        type: 'email',
        recipient_email: to,
        subject: `Recommendation Request from ${athleteName}`,
        content: `<p><strong>${athleteName}</strong> has requested a recommendation on RecruitLook.</p><p>Athlete ID: ${athleteId}</p>`,
        metadata: {
          trigger_source: 'recommendation_request',
          athlete_name: athleteName,
          athlete_id: athleteId
        }
      }
    });

    if (error) {
      throw new Error(error.message);
    }

    return { success: true };
  } catch (error) {
    console.error("Failed to queue email:", error);
    throw error;
  }
}

/**
 * Send a generic email via the RecruitLook backend
 * @param to Recipient email address
 * @param subject Email subject
 * @param text Plain text version of the email
 * @param html HTML version of the email
 */
export async function sendEmail(to: string, subject: string, text: string, html: string): Promise<any> {
  console.log("Queueing generic email via Communication Hub to:", to);

  try {
    const { error } = await invokeEdgeFunction('queue-communication', {
      body: {
        type: 'email',
        recipient_email: to,
        subject,
        content: html || text,
        metadata: {
          trigger_source: 'lib_send_email',
          text_fallback: text || null
        }
      }
    });

    if (error) {
      throw new Error(error.message);
    }

    return { success: true };
  } catch (error) {
    console.error("Failed to queue email:", error);
    throw error;
  }
}